import fetchClient from '../api/api-client'

export const getAllPackages = async filter => {
  try {
    const res = await fetchClient.post(`/packages/all`, filter)
    // console.log("getAllPackages - res:", res)

    return res.data.data.response
  } catch (error) {
    throw error
  }
}

export const getPackagesStats = async filter => {
  try {
    const res = await fetchClient.post(`/packages/stats`, filter)
    return res.data.data.response
  } catch (error) {
    throw error
  }
}

export const createPackage = async data => {
  try {
    const payload = {
      data,
    }

    const res = await fetchClient.post(`/packages`, payload)
    // console.log("createPackage - res:", res)

    return res.data.data
  } catch (err) {
    throw err
  }
}
export const getUserPackages = async () => {
  try {
    const res = await fetchClient.get('/packages')
    return res.data.data.response
  } catch (error) {
    throw error
  }
}

export const getPackages = async filter => {
  try {
    const res = await fetchClient.post('/packages/filter', filter)
    // console.log("getPackages - res:", res.data.data.response)

    return res.data.data.response
  } catch (error) {
    throw error
  }
}

export const getPackageById = async id => {
  try {
    const result = await fetchClient.get(`/packages/${id}`)
    // console.log("getPackageById - result:", result.data.data.response)
    if (result.data.data.response.length === 0) throw 'Package not found!'

    return result.data.data.response[0]
  } catch (error) {
    throw error
  }
}

export const getPackageByTrackingNumberInTurkey = async trackingNumber => {
  try {
    const result = await fetchClient.get(`/packages/trackingNumberInTurkey/${trackingNumber}`)
    return result.data.data.response
  } catch (error) {
    throw error
  }
}

export const getPackageByXlt = async xlt => {
  try {
    const result = await fetchClient.get(`/packages/xlt/${xlt}`)
    const pkgs = result.data.data.response
    return pkgs?.filter(p => !p.unitedPackageId)?.[0]
  } catch (error) {
    throw error
  }
}

export const getPackagesByIndex = async (data, filter) => {
  try {
    const payload = {
      data,
      filter,
    }

    const res = await fetchClient.post(`/packages/by_index`, payload)
    // console.log("getPackagesByIndex - res:", res)

    return res.data.data.response
  } catch (error) {
    throw error
  }
}

export const updatePackage = async (id, body) => {
  try {
    const res = await fetchClient.patch(`/packages/${id}`, body)
    // console.log("updatePackage - result:", result)

    return res.data
  } catch (error) {
    throw error
  }
}

export const deletePackage = async id => {
  try {
    const result = await fetchClient.delete(`/packages/${id}`)
    // console.log("deletePackage - result:", result)

    return result
  } catch (error) {
    throw error
  }
}

export const generateWarehouseReport = async (warehouse, month) => {
  try {
    const response = await fetchClient.post(
      '/packages/warehouse-report',
      { warehouse, month },
      {
        responseType: 'blob',
      }
    )
    return response.data
  } catch (error) {
    throw error
  }
}
